import React from 'react'
import classNames from 'classnames'

export default function Divider({ className, ...props }) {
  return <div className={classNames('et-divider', className)} {...props}></div>
}
